import { render, staticRenderFns } from "./GenerateDocumentModal.vue?vue&type=template&id=48d33c28&scoped=true&"
import script from "./GenerateDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./GenerateDocumentModal.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateDocumentModal.vue?vue&type=style&index=0&id=48d33c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d33c28",
  null
  
)

export default component.exports